export const pricingData = [
	{
		title: 'Java',
		price: '$5.99 user/month after offer period',
		features: ['Teaches Java', 
		'Making Project',
		 'One-on-One Teaching',
		  'Part of Future Projects',
		   'Flexible Hrs'],
	},
	{
		title: 'Python',
		price: '7.99 user/month after offer period',
		features: ['Learn Python', 
		'Making Project',
		 'One-on-One Teaching',
		  'Part of Future Projects',
		   'Flexible Hrs'],
	},
	{
		title: 'Ruby',
		price: '9.99 user/month after offer period',
		features: ['Learn Ruby', 
		'Making Project',
		 'One-on-One Teaching',
		  'Part of Future Projects',
		   'Flexible Hrs'],
	},
	{
		title: 'C++',
		price: '15.99 user/month after offer period',
		features: ['Learn C++', 
		'Making Project',
		 'One-on-One Teaching',
		  'Part of Future Projects',
		   'Flexible Hrs'],
	},
	{
		title: 'JavaScript',
		price: '18.99 user/month after offer period',
		features: ['Learn JavaScript', 
		'Making Project',
		 'One-on-One Teaching',
		  'Part of Future Projects',
		   'Flexible Hrs'],
	},

	{
		title: 'Bundle',
		price: '29.99 user/month after offer period ',
		features: ['Learn All Languages', 
		'Making Project',
		 'One-on-One Teaching',
		  'Part of Future Projects',
		   'Flexible Hrs'],
	},
];
